import { useOnboardingStore } from "../../stores/onboardingStore";

const TOTAL_TOPICS = 7;

export function OnboardingProgress() {
  const { messages } = useOnboardingStore();

  // Count completed topics by counting assistant messages
  const assistantMessages = messages.filter((m) => m.role === "assistant");
  const completedTopics = Math.min(assistantMessages.length, TOTAL_TOPICS);

  return (
    <div className="flex items-center gap-1.5">
      {Array.from({ length: TOTAL_TOPICS }, (_, i) => (
        <div
          key={i}
          className={`w-2 h-2 rounded-full transition-colors ${
            i < completedTopics ? "bg-brand-600" : "bg-gray-200"
          }`}
        />
      ))}
    </div>
  );
}
